import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-aa4c7628")

_pushScopeId("data-v-aa4c7628")
const _hoisted_1 = { class: "person__wrapper" }
const _hoisted_2 = { class: "person__select" }
const _hoisted_3 = { class: "person__select " }
const _hoisted_4 = { class: "person__select " }
const _hoisted_5 = { class: "person__select " }
const _hoisted_6 = { class: "person__select " }
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_common_selector = _resolveComponent("common-selector")
  const _component_error_msg_person = _resolveComponent("error-msg-person")
  const _component_budget_codes_selector = _resolveComponent("budget-codes-selector")
  const _component_show_person = _resolveComponent("show-person")

  return (_openBlock(), _createBlock("div", {
    class: ["person__create form_person", { noMargin: _ctx.isShowMode }]
  }, [
    (!_ctx.isShowMode)
      ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
          _createVNode("div", _hoisted_1, [
            _createVNode("div", _hoisted_2, [
              _createVNode(_component_common_selector, {
                isImportant: true,
                type: _ctx.personType,
                placeholder: "Персона",
                onItemSet: _cache[1] || (_cache[1] = $event => (_ctx.setData($event, 'passenger'))),
                subListId: _ctx.contractId,
                onStartSearch: _cache[2] || (_cache[2] = $event => (_ctx.setError('person'))),
                onEndSearch: _cache[3] || (_cache[3] = $event => (_ctx.setError('person', $event)))
              }, null, 8, ["type", "subListId"]),
              _createVNode(_component_error_msg_person, {
                show: _ctx.errorSearhc.person
              }, null, 8, ["show"])
            ]),
            _createVNode("button", {
              onClick: _cache[4] || (_cache[4] = (...args) => (_ctx.deletePersone(...args))),
              class: "btn-close mt-8 ml-8"
            })
          ]),
          (_ctx.personId && _ctx.showEl)
            ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                _createVNode("div", _hoisted_3, [
                  _createVNode(_component_common_selector, {
                    isImportant: true,
                    type: _ctx.docType,
                    placeholder: "Документ",
                    onItemSet: _cache[5] || (_cache[5] = $event => (_ctx.setData($event, 'document'))),
                    subListId: _ctx.personId,
                    onStartSearch: _cache[6] || (_cache[6] = $event => (_ctx.setError('document'))),
                    onEndSearch: _cache[7] || (_cache[7] = $event => (_ctx.setError('document', $event)))
                  }, null, 8, ["type", "subListId"]),
                  _createVNode(_component_error_msg_person, {
                    show: _ctx.errorSearhc.document
                  }, null, 8, ["show"])
                ]),
                _createVNode("div", _hoisted_4, [
                  _createVNode(_component_common_selector, {
                    type: _ctx.bonusType,
                    placeholder: "Бонусная карта",
                    onItemSet: _cache[8] || (_cache[8] = $event => (_ctx.setData($event, 'bonusCard'))),
                    subListId: _ctx.personId,
                    onStartSearch: _cache[9] || (_cache[9] = $event => (_ctx.setError('bonusCard'))),
                    onEndSearch: _cache[10] || (_cache[10] = $event => (_ctx.setError('bonusCard', $event)))
                  }, null, 8, ["type", "subListId"]),
                  _createVNode(_component_error_msg_person, {
                    show: _ctx.errorSearhc.bonusCard
                  }, null, 8, ["show"])
                ]),
                _createVNode("div", _hoisted_5, [
                  _createVNode(_component_common_selector, {
                    type: _ctx.emailType,
                    placeholder: "E-mail",
                    onItemSet: _cache[11] || (_cache[11] = $event => (_ctx.setData($event, 'email'))),
                    subListId: _ctx.personId,
                    onStartSearch: _cache[12] || (_cache[12] = $event => (_ctx.setError('email'))),
                    onEndSearch: _cache[13] || (_cache[13] = $event => (_ctx.setError('email', $event)))
                  }, null, 8, ["type", "subListId"]),
                  _createVNode(_component_error_msg_person, {
                    show: _ctx.errorSearhc.email
                  }, null, 8, ["show"])
                ]),
                _createVNode("div", _hoisted_6, [
                  _createVNode(_component_common_selector, {
                    type: _ctx.phoneType,
                    placeholder: "Телефон",
                    onItemSet: _cache[14] || (_cache[14] = $event => (_ctx.setData($event, 'phone'))),
                    subListId: _ctx.personId,
                    onStartSearch: _cache[15] || (_cache[15] = $event => (_ctx.setError('phone'))),
                    onEndSearch: _cache[16] || (_cache[16] = $event => (_ctx.setError('phone', $event)))
                  }, null, 8, ["type", "subListId"]),
                  _createVNode(_component_error_msg_person, {
                    show: _ctx.errorSearhc.phone
                  }, null, 8, ["show"])
                ]),
                (_ctx.showBudgetCodes)
                  ? (_openBlock(), _createBlock(_component_budget_codes_selector, {
                      key: 0,
                      ContractId: _ctx.contractId,
                      offerPersonId: _ctx.personId,
                      onSetData: _cache[17] || (_cache[17] = $event => (_ctx.setData($event, 'budgetCodes')))
                    }, null, 8, ["ContractId", "offerPersonId"]))
                  : _createCommentVNode("", true)
              ], 64 /* STABLE_FRAGMENT */))
            : _createCommentVNode("", true)
        ], 64 /* STABLE_FRAGMENT */))
      : (_openBlock(), _createBlock(_component_show_person, {
          key: 1,
          dataShow: _ctx.dataShow,
          ContractId: _ctx.contractId
        }, null, 8, ["dataShow", "ContractId"]))
  ], 2))
})